module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHklEQVQImWPYkR/w/8myov8SIqr/mRiQAILDwMAAAN7BBsYsi2YmAAAAAElFTkSuQmCC"